import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Pricing } from "@/components/Pricing";
import { Inclusions } from "@/components/Inclusions";
import { Testimonial } from "@/components/Testimonial";
import { LeadForm } from "@/components/LeadForm";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { EnquireModal } from "@/components/EnquireModal";
import Admin from "@/pages/Admin";

const Landing = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Pricing />
        <Inclusions />
        <Testimonial />
        <LeadForm />
        <FAQ />
      </main>
      <Footer />
      <WhatsAppFloat />
      <EnquireModal />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="bottom-center" theme="light" />
    </BrowserRouter>
  );
}

export default App;
